<template>
  <div class="finish">

    <div class="finish__body">
      <p>С этим мероприятием у вас точно сложится любовь</p>
    </div>

    <div class="finish__image">
      <img :src="images[result]" alt="" ref="img">
    </div>

    <div class="finish__share" ref="share"></div>

    <div class="finish__body"><p>Делитесь Ивентинкой с друзьями в социальных сетях и отмечайте, с кем отправитесь на заветное мероприятие ❤️</p></div>

    <a href="/valentine-2020" class="finish__btn">Пройти тест</a>

  </div>
</template>

<script>
export default {
  props: {
    result: {
      type: Number
    }
  },

  mounted() {
    window.location = `https://eventum-premo.ru/valentine-2020/${this.urls[this.result]}.html`
    // const imgUrl = this.$refs.img.getAttribute('src')
    // const imgFullPath = `https://eventum-premo.ru/valentine-2020${imgUrl}`
    //
    // const share = window.Ya.share2(this.$refs.share, {
    //   content: {
    //     url: 'https://eventum-premo.ru/valentine-2020/',
    //     title: 'Тест ко Дню святого Валентина «Ивентинка»',
    //     description: 'Узнай, с каким мероприятием у вас точно сложится особая любовь и понимание.',
    //     image: imgFullPath
    //   },
    //   theme: {
    //     services: 'facebook,vkontakte,telegram,twitter,whatsapp'
    //   }
    // })
  },

  data() {
    return {
      images: {
        0: require('@/assets/fashion.jpg'),
        1: require('@/assets/oskar.jpg'),
        2: require('@/assets/burning-man.jpg'),
        3: require('@/assets/fifa.jpg'),
        4: require('@/assets/superbowl.jpg'),
        5: require('@/assets/leons.jpg'),
        6: require('@/assets/karnaval.jpg'),
        7: require('@/assets/biennale.jpg'),
        8: require('@/assets/met-gala.jpg'),
        9: require('@/assets/nobel.jpg')
      },
      urls: {
        0: 'fashion',
        1: 'oskar',
        2: 'burning-man',
        3: 'fifa',
        4: 'superbowl',
        5: 'leons',
        6: 'karnaval',
        7: 'biennale',
        8: 'met-gala',
        9: 'nobel',
      }
    }
  }
}
</script>
